import React from "react";
import "./index.css";
import errorIcon from "@assets/error.svg";

interface PopupProps {
  title: string;
  message: string;
  onClose: () => void;
}

const ErrorPopup: React.FC<PopupProps> = ({ title, message, onClose }) => {
  return (
    <div className="popup-error-overlay">
      <div className="popup-error">
        <img src={errorIcon} alt="errorIcon" className="error-icon" />
        <h1 className="error-popup-title">{title}</h1>
        <br />
        <p>{message}</p>
        <br />
        <button className="popup-error-button" onClick={onClose}>
          Aceptar
        </button>
      </div>
    </div>
  );
};

export default ErrorPopup;
